var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { UserProvider } from './user';
import { DatasetType } from './dataset';
import { BrainVersionType } from './brain';
export var Brand;
(function (Brand) {
    Brand["Sony"] = "Sony";
    Brand["FLIR"] = "FLIR";
    Brand["None"] = "None";
})(Brand || (Brand = {}));
export var BrandSensor;
(function (BrandSensor) {
    BrandSensor["SonyIMX500"] = "IMX 500";
    BrandSensor["FLIRFireflyDL"] = "Firefly DL";
    BrandSensor["None"] = "";
})(BrandSensor || (BrandSensor = {}));
export var DownloadState;
(function (DownloadState) {
    DownloadState[DownloadState["Initializing"] = 0] = "Initializing";
    DownloadState[DownloadState["Ready"] = 1] = "Ready";
    DownloadState[DownloadState["Downloading"] = 2] = "Downloading";
    DownloadState[DownloadState["Error"] = 3] = "Error";
})(DownloadState || (DownloadState = {}));
var WhiteLabelProvider = /** @class */ (function (_super) {
    __extends(WhiteLabelProvider, _super);
    function WhiteLabelProvider(userProvider) {
        var _this = _super.call(this) || this;
        _this.userProvider = userProvider;
        _this.brainName = null;
        _this.sensorName = null;
        return _this;
    }
    WhiteLabelProvider.prototype.getBrainName = function () {
        if (this.brainName !== undefined && this.brainName != null) {
            return this.brainName;
        }
        var brand = this.getBrand();
        this.brainName = this.getBrainNameFromBrand(brand);
        return this.brainName;
    };
    WhiteLabelProvider.prototype.getSensorName = function () {
        if (this.sensorName !== undefined && this.sensorName != null) {
            return this.sensorName;
        }
        var brand = this.getBrand();
        this.sensorName = this.getSensorNameFromBrand(brand);
        return this.sensorName;
    };
    WhiteLabelProvider.prototype.getBrand = function () {
        if (this.userProvider.isFireflyUser()) {
            return Brand.FLIR;
        }
        else if (this.userProvider.isSonyUser()) {
            return Brand.Sony;
        }
        else {
            return Brand.None;
        }
    };
    /**
     * Generate the full brain name, which may include the company name or not
     * This is what will be shown on the Evaluate Page and titles/buttons generally
     */
    WhiteLabelProvider.prototype.getBrainNameFromBrand = function (brand) {
        if (brand == Brand.FLIR) {
            return Brand.FLIR + " " + BrandSensor.FLIRFireflyDL;
        }
        else if (brand == Brand.Sony) {
            return BrandSensor.SonyIMX500;
        }
        return null;
    };
    /**
     * Just return the sensor name.  This might be used if we don't want
     * to include the company name, or if we have to shorten the string a bit.
     */
    WhiteLabelProvider.prototype.getSensorNameFromBrand = function (brand) {
        if (brand == Brand.FLIR) {
            return BrandSensor.FLIRFireflyDL;
        }
        else if (brand == Brand.Sony) {
            return BrandSensor.SonyIMX500;
        }
        return null;
    };
    WhiteLabelProvider.prototype.resetInfo = function () {
        this.brainName = null;
    };
    WhiteLabelProvider.prototype.getRequiredBrainVersionType = function (dataset) {
        switch (dataset.type) {
            case DatasetType.SceneRecognition:
                return BrainVersionType.Frozen;
            case DatasetType.AnomalyRecognition:
                return BrainVersionType.AnomalyHiFi;
            case DatasetType.ObjectDetection:
            default:
                return BrainVersionType.Learning;
        }
    };
    WhiteLabelProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [UserProvider])
    ], WhiteLabelProvider);
    return WhiteLabelProvider;
}(BaseProvider));
export { WhiteLabelProvider };
//# sourceMappingURL=white-label.js.map


// WEBPACK FOOTER //
// ./src/providers/white-label.ts.pre-build-optimizer.js